import { useEffect } from "react";
import { useNotificationCenter } from "./store";
// Снять префикс «(N) » с начала заголовка — чтобы не накапливать «(1) (2) …».
const stripUnreadPrefix = (title) => title.replace(/^\(\d+\)\s+/, "");
/**
 * Префикс «(N) …» в заголовке вкладки браузера при непрочитанных уведомлениях.
 * Базовый заголовок ставит per-route Seo (см. shared/components/Seo) — мы лишь
 * добавляем/снимаем префикс. Seo переписывает `document.title` на навигации,
 * поэтому переустанавливаем префикс не только при смене unreadCount, но и по
 * MutationObserver на `<title>` (ловим внешнюю смену базового заголовка).
 * Наша собственная запись префикса нового мутации не порождает (desired ===
 * текущему после strip), так что цикла нет.
 */
export const useUnreadTabTitle = () => {
    const unreadCount = useNotificationCenter((s) => s.unreadCount);
    useEffect(() => {
        if (typeof document === "undefined")
            return;
        const apply = () => {
            const base = stripUnreadPrefix(document.title);
            const desired = unreadCount > 0 ? `(${unreadCount}) ${base}` : base;
            if (document.title !== desired)
                document.title = desired;
        };
        apply();
        const titleEl = document.querySelector("title");
        if (!titleEl)
            return;
        const observer = new MutationObserver(() => apply());
        observer.observe(titleEl, {
            childList: true,
            characterData: true,
            subtree: true,
        });
        return () => observer.disconnect();
    }, [unreadCount]);
};
/**
 * Авто-прочтение уведомлений «голос готов» пока пользователь на экране ожидания
 * голоса (открыт менеджер голосов / рекордер, либо страница генерации со списком
 * голосов). Он и так видит результат на экране — незачем копить `voice_ready` в
 * бейдже. Помечаем прочитанными и уже пришедшие (бэклог), и новые live.
 */
export const useAutoReadVoiceReady = (active) => {
    const items = useNotificationCenter((s) => s.items);
    const markOne = useNotificationCenter((s) => s.markOne);
    useEffect(() => {
        if (!active)
            return;
        for (const n of items) {
            if (n.type === "voice_ready" && !n.is_read)
                void markOne(n.id);
        }
    }, [active, items, markOne]);
};
